// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"6a143820","373":"6c29cc65","388":"5014fc33","613":"e2524876","666":"780d113c","924":"4e751863","931":"11732752","982":"3fe13715"}[chunkId] + ".chunk.js";
};